import { fetchPromoCode, GET } from "../api";

export const setReferenceCode = ($input, $form) => {
  const $submitBtn = $form.find(".submit");

  $input.on("blur", (e) => {
    const fieldWrap = $(e.target).parent();
    const errorField = fieldWrap.find(".error-field");
    const successField = fieldWrap.find(".success-field");
    $submitBtn.prop("disabled", true);

    if (e.target.value === "") {
      successField.remove();
      fieldWrap.removeClass("error");
      errorField.text("");
      $submitBtn.prop("disabled", false);
      return;
    }

    fetchPromoCode(e.target.value, GET)
      .then((responseData) => {
        const isCodeValid = responseData.success;
        $submitBtn.prop("disabled", false);

        if (isCodeValid) {
          fieldWrap.removeClass("error");
          errorField.text("");
          fieldWrap.addClass("success");

          if (successField.length > 0) {
            successField.text(window.translate.code_accepted);
            return;
          }

          $(e.target).after(
            `<div class='success-field'>${window.translate.code_accepted}</div>`
          );
          return;
        }

        successField.remove();
        fieldWrap.addClass("error");
        errorField.text(responseData.error);
      })
      .catch(() => {
        successField.remove();
        fieldWrap.addClass("error");
        errorField.text(window.translate.error_with_request);
        $submitBtn.prop("disabled", false);
      });
  });
};
